import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ChartConfiguration } from 'chart.js';
import { environment } from '../../../../environments/environment';
import { IEngagementReportOLD } from '../../../utils/interfaces/engagement.report';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class EngagementReportService {
  private readonly URI_API = environment.apiConfig.uri + 'EngagementReport';

  constructor(private readonly httpClient: HttpClient) {}

  getEngagementReport(
    filter: IReportFilter
  ): Observable<IResponse<ChartConfiguration<'bar'>['data']>> {
    return this.httpClient
      .post<IResponse<IEngagementReportOLD[]>>(
        `${this.URI_API}/engagement`,
        filter
      )
      .pipe(
        map(
          (res): IResponse<ChartConfiguration<'bar'>['data']> =>
            this.transformDataEngagementReport(res)
        )
      );
  }

  /**
   *
   * @param res resposta do relatório de engajamento
   * @returns Resposta do relatório de engajamento com o novo formato de dados
   */
  private transformDataEngagementReport(
    res: IResponse<IEngagementReportOLD[]>
  ): IResponse<ChartConfiguration<'bar'>['data']> {
    const newData: ChartConfiguration<'bar'>['data'] = {
      labels: res.data.some((d) => d.year)
        ? res.data.map((r) => `${r.month}/${r.year}`)
        : [],
      datasets: [
        {
          label: 'Avaliações completas',
          data: res.data.map((r) => r.percentCompleted),
          backgroundColor: '#BE0013',
          borderColor: '#BE0013',
          borderWidth: 1,
          custom: res.data.map((r) => r.totalCompleted).toString(),
        },
        {
          label: 'Avaliações incompletas',
          data: res.data.map((r) => r.percentIncomplete),
          backgroundColor: '#8E9199',
          borderColor: '#8E9199',
          borderWidth: 1,
          custom: res.data.map((r) => r.totalIncomplete).toString(),
        },
      ] as any,
    };

    return {
      ...res,
      data: newData,
    };
  }
}
